export enum UpdateUserSuccess {
  SUCCESS = 200,
}

export enum UpdateUserError {
  INFOMATION_INVALID = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  USER_NOTE_FOUND = 404,
  LEADER_HAS_AGENCY = 406,
  USER_ALREADY_EXISTS = 409,
  INTERNAL_SERVER_ERROR = 500,
}

export const UpdateUserSuccessDefined = {
  [UpdateUserSuccess.SUCCESS]: {
    message: 'Cập nhật thành công',
  },
};

export const UpdateUserErrorDefined = {
  [UpdateUserError.INFOMATION_INVALID]: {
    message:
      'Thông tin không hợp lệ, PC này không tồn tại trưởng nhóm, Cập nhật thất bại',
  },
  [UpdateUserError.UNAUTHORIZED]: {
    message: 'Tài khoản không có quyền truy cập',
  },
  [UpdateUserError.FORBIDDEN]: {
    message: 'Tài khoản không có quyền truy cập',
  },
  [UpdateUserError.USER_NOTE_FOUND]: {
    message: 'Tài khoản không tồn tại',
  },
  [UpdateUserError.LEADER_HAS_AGENCY]: {
    message: 'Không thể xoá trưởng nhóm có đại lý',
  },
  [UpdateUserError.USER_ALREADY_EXISTS]: {
    message:
      'Tài khoản đã tồn tại, Điện lực này đã tồn tại tài khoản, PC này đã tồn tại trưởng nhóm',
  },
  [UpdateUserError.INTERNAL_SERVER_ERROR]: {
    message: 'Đã có lỗi xảy ra, vui lòng thử lại sau',
  },
};
